'use es6';

import { useState } from 'react';
import PropTypes from 'prop-types';
import { MoveableArea } from 'foundations-components/transitional/components/MoveableArea';
import { View } from 'foundations-components/transitional/components/View';
import { SpecialFieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import invisibleRecaptchaPreviewImage from 'bender-url!FormsUI/img/editor/invisible-recaptcha-preview.png';
import FormFieldFloatingInfoButtonGroup from './FormFieldFloatingInfoButtonGroup';
import { CommentableArea } from 'collaboration-sidebar';
import { isCaptchaSelected } from 'FormsUI/utils/SpecialFields';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { DELETE_CATCHA_INFO_BUTTON_GROUP, TOGGLE_INFO_CAPTCHA_INFO_BUTTON_GROUP } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
export const Captcha = ({
  updateValueOnFormDefinition,
  selectedFormItemType,
  selectedFormItemReference,
  handleSelect
}) => {
  const [isInfoClicked, setIsInfoClicked] = useState(false);
  const handleSelectChange = ({
    target: {
      value
    }
  }) => {
    handleSelect(value);
  };
  const handleDelete = () => {
    updateValueOnFormDefinition({
      captchaEnabled: false
    });
    trackEditorInteraction(DELETE_CATCHA_INFO_BUTTON_GROUP);
    handleSelect(false);
  };
  const handleInfo = () => {
    trackEditorInteraction(TOGGLE_INFO_CAPTCHA_INFO_BUTTON_GROUP, {
      value: [!isInfoClicked ? 'enabled' : 'disabled']
    });
    handleSelect(!isInfoClicked);
    setIsInfoClicked(!isInfoClicked);
  };
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    id: "captcha-preview",
    "data-test-id": "captcha-preview",
    children: /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: "captcha",
      description: {
        translationKey: 'formsCaptchaField'
      },
      children: /*#__PURE__*/_jsx(FormFieldFloatingInfoButtonGroup, {
        handleInfo: handleInfo,
        handleDelete: handleDelete,
        children: /*#__PURE__*/_jsx(MoveableArea, {
          draggable: false,
          containerDraggable: true,
          display: "inline-block",
          "data-test-id": "moveable-captcha-preview",
          selected: isCaptchaSelected({
            selectedFormItemType,
            selectedFormItemReference
          }),
          onSelectedChange: handleSelectChange,
          children: /*#__PURE__*/_jsx("img", {
            src: invisibleRecaptchaPreviewImage
          })
        })
      })
    })
  });
};
Captcha.propTypes = {
  selectedFormItemType: PropTypes.oneOf([...Object.values(FieldTypes || {}), ...Object.values(SpecialFieldTypes || {})]),
  selectedFormItemReference: PropTypes.string,
  handleSelect: PropTypes.func.isRequired,
  updateValueOnFormDefinition: PropTypes.func.isRequired
};
export default Captcha;